<template>
  <div>
    <div class="justifiy-content-center">
      <h2>顧客一覧</h2>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="customers"
        :item-key="customers.ID"
        @click:row="move"
        :footer-props="{
          'items-per-page-text': '行/ページ:',
        }"
        :items-per-page="-1"
        :sort-by="['ID']"
        :sort-desc="[desc]"
      >
        <template v-slot:item.link="{ item }">
          <td>
            <v-btn
              @click="moveSite(item.name)"
              color="yellow lighten-2 orange--text"
              :disabled="!mvlink"
            >
              デモサイト
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
    <v-btn @click="move_dev_setting()" color="primary" class="ma-2">
      developer処理
    </v-btn>
    <v-btn @click="move_cus_setting()" color="primary" class="ma-2">
      customer作成
    </v-btn>
    <v-btn @click="move_emp_setting()" color="primary" class="ma-2">
      employee作成
    </v-btn>
    <v-btn @click="move_mock_create()" color="primary" class="ma-2" disabled>
      デモ画面作成
    </v-btn>
    <v-btn @click="getEmployeeLasLogin()" color="primary" class="ma-2">
      顧客ログイン情報
    </v-btn>
    <v-btn @click="moveAnalysis()" color="primary" class="ma-2">
      調査・分析
    </v-btn>
  </div>
</template>

<script>
import { RepositoryFactory } from "../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

//認証情報だけを飛ばす
//DBからcstomer一覧を取得する

export default {
  name: "Home",
  data() {
    return {
      drawer: true,
      isLoading: false,
      fullPage: false,
      customers: [],
      //
      IdOrder: false,
      mvlink: false,
      desc: true,
    };
  },
  async mounted() {
    if (this.$store.state.accessToken) {
      await this.getInit();
    }
    if (process.env.NODE_ENV == "development") {
      this.desc = false;
    }
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      if (process.env.NODE_ENV == "development") {
        this.mvlink = false;
      }
      //取得
      this.setIndex(await api.getCustomer());
      //読み込み終了
      this.isLoading = false;
    },
    move(row) {
      this.$store.commit("setCustomerID", row.ID);
      this.$store.commit("setCustomerName", row.name);
      this.$router.push({ path: "/customer/" + row.ID });
    },
    move_dev_setting() {
      this.$router.push({ path: "/developer/index" });
    },
    move_cus_setting() {
      this.$router.push({ path: "/customer/project/home" });
    },
    move_emp_setting() {
      this.$router.push({ path: "/employee/home" });
    },
    move_mock_create() {
      this.$router.push({ path: "/mock/create" });
    },
    moveAnalysis() {
      this.$router.push({ path: "/analysis" });
    },
    moveSite(customer) {
      const URL = "https://service.kakanai.com/" + customer;
      window.open(URL, "_blank");
    },
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    //localstarage関連
    setIndex(customers) {
      this.customers = customers;
      /*
      let localData = JSON.parse(localStorage.getItem("seisei_front"));
      if (localData == null) {
        customers.forEach((customer, index) => {
          this.customers[index].index = index;
        });
      }
      //
      localStorage.setItem(
        "seisei_front_cusotmer_order",
        JSON.stringify(customers)
      );
      */
    },
    //
    async getEmployeeLasLogin() {
      const request = {
        customers: [],
      };
      //取得
      const response = await api.EmployeeLasLogin(request);
      console.log("getEmployeeLasLogin", response);
    },
  },
  computed: {
    headers() {
      return [
        { text: "CustomerID", value: "ID", width: "10%", sortable: true },
        { text: "顧客名", value: "name", align: "start", sortable: true },
        { text: "備考", value: "detail", sortable: true },
        { text: "リンク", value: "link", width: "10%", sortable: true },
      ];
    },
  },
};
</script>
